import { HSpacer, Text } from "@/components/DesignSystem";
import {
  SubwalletAccordionListItem,
} from "@/pages/Admin/HierarchyOfRetailers/Wallet/SubwalletAccordionListItem";
import { SubwalletEndpoint } from '@api/endpoints';
import { Box, Divider, Grid, Stack } from "@mui/material";
import React from "react";

interface SubwalletListProps {
  onEditClicked?: (subwalletId: string) => void,
  subwallets: SubwalletEndpoint.List.ResolvedApiSubwalletListItem[],
}

const SubwalletList = ({
  onEditClicked,
  subwallets,
}: SubwalletListProps) => {
  return (
    <Stack>
      <Box sx={{ paddingY: '16px' }}>
        <Grid alignItems="center" container spacing={2}>
          <Grid item sm={4} xs={12}>
            <Stack direction="row">
              <HSpacer size="7" />
              <Text category="title-small" fontWeight={500} marginLeft="40px">
                Subwallet name
              </Text>
            </Stack>
          </Grid>
          <Grid item sm={3} xs={6}>
            <Text category="title-small" fontWeight={500}>
              Parent record
            </Text>
          </Grid>
          <Grid item sm={3} xs={6}>
            <Text category="title-small" fontWeight={500}>
              Last updated
            </Text>
          </Grid>
        </Grid>
      </Box>
      <Divider />
      {!subwallets.length && (
        <Stack alignItems='center' direction='column' justifyContent='center' marginTop='48px'>
          <Text category="body-xlarge">
            0 subwallets
          </Text>
        </Stack>
      )}
      {subwallets.map(subwallet => (
        <Stack key={subwallet.id}>
          <SubwalletAccordionListItem
            onEditClicked={() => onEditClicked && onEditClicked(subwallet.id)}
            subwallet={subwallet}
          />
          <Divider />
        </Stack>
      ))}
    </Stack>
  );
};

export default SubwalletList;
